export default __webpack_public_path__ + "static/land-tier-4-0a18f987f9143170b356cb4a1f38c3c9.png";